import {store} from "../../store";
import * as actionTypes from "./actionTypes";
import {EventLogsService} from "../../../api/eventLogsService";
import moment from "moment";
import {toastError} from "../../../shared/components/toast/Toast";
import fileSaver from 'file-saver'

export const getEventsData = (integrationId, page, rowsPerPage, sorting, filter) => {
    const sortParts = sorting.split(',')
    const ruleName = filter.ruleConfigurationName.value
    const msisdn = filter.msisdn.value
    const startDate = filter.triggerDate.from ? moment(filter.triggerDate.from).format("YYYYMMDD") : undefined
    const endDate = filter.triggerDate.to ? moment(filter.triggerDate.to).format("YYYYMMDD") : undefined
    const serviceType = filter.accumulatorService.value
    const ruleType = filter.tipologia.value

    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_EVENTS_DATA, value: true})
        EventLogsService.fetchEventsData(integrationId, page, rowsPerPage, sortParts[0], sortParts[1].toUpperCase(),
            ruleType, msisdn, ruleName, serviceType, startDate, endDate)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_EVENTS_DATA,
                    payload: res.data.eventLogs ?? [],
                    count: res.data.totalElements ?? 0
                })
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_EVENTS_DATA, value: false})
            })
    }
}

export const getEventDetailsData = (eventLogId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.SET_EVENT_DETAILS_DATA_LOADING, value: true})

        EventLogsService.fetchEventDetailsData(integrationId, eventLogId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_EVENT_DETAILS_DATA,
                    payload: res.data
                })
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_EVENT_DETAILS_DATA_LOADING, value: false})
            })
    }
}

export const downloadEventLogsToCsv = (selectedEventLogs, areAllSelected, integrationId, sorting, filter) => {
    const sortParts = sorting.split(',')
    const ruleName = filter.ruleConfigurationName.value
    const msisdn = filter.msisdn.value
    const startDate = filter.triggerDate.from ? moment(filter.triggerDate.from).format("YYYYMMDD") : undefined
    const endDate = filter.triggerDate.to ? moment(filter.triggerDate.to).format("YYYYMMDD") : undefined
    const serviceType = filter.accumulatorService.value
    const ruleType = filter.tipologia.value

    return (dispatch) => {
        dispatch({type: actionTypes.SET_EVENT_LOGS_DOWNLOAD_CSV_LOADING, payload: true})
        EventLogsService.downloadCsv(selectedEventLogs, areAllSelected, integrationId,
            sortParts[0], sortParts[1].toUpperCase(), ruleType, msisdn, ruleName, serviceType, startDate, endDate)
            .then((res) => {
                fileSaver.saveAs(res.data, `event_logs_${new Date().toISOString()}.csv`)
            })
            .catch((e) => {
                toastError('Errore durante il download del file CSV')
                console.log(e);
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_EVENT_LOGS_DOWNLOAD_CSV_LOADING, payload: false})
            })
    }
}
